import { defineMessages } from 'react-intl';

export default defineMessages({
  closeButton: {
    id: 'frontbucket.repository.source.file.lfsInfo.closeButton',
    description: 'Link to view all LFS files in a repository',
    defaultMessage: 'Close',
  },
  description: {
    id: 'frontbucket.repository.source.file.lfsInfo.description',
    description: 'Link to view all LFS files in a repository',
    defaultMessage:
      'The LFS repository stores a text pointer to this file, which is actually stored on a remote server.',
  },
  header: {
    id: 'frontbucket.repository.source.file.lfsInfo.header',
    description: 'Link to view all LFS files in a repository',
    defaultMessage: 'File stored in Git LFS',
  },
  learnMoreLink: {
    id: 'frontbucket.repository.source.file.lfsInfo.learnMoreLink',
    description: 'Link to view all LFS files in a repository',
    defaultMessage: 'Read about Git LFS.',
  },
  viewAllLfsFilesLink: {
    id: 'frontbucket.repository.source.file.lfsInfo.viewAllFilesLink',
    description: 'Link to view all LFS files in a repository',
    defaultMessage: 'View all Git LFS files',
  },
});
